export default {
    webUnderConstruction: "images/icons/errors/maintenanceTasks.svg",
    webUnderConstructionMobile: "images/icons/errors/maintenanceTasks.svg",
};
